module.exports = __webpack_public_path__ + "media/images/categories/judging-52234151688ed5011017cdecbf5cd918.png";